// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function footer1_viewportEnter(event) {
	//Add your code for this event here: 
}

export function footer1_viewportLeave(event) {
	//Add your code for this event here: 
}

export function footer1_mouseIn(event) {
	//Add your code for this event here: 
}

export function footer1_mouseOut(event) {
	//Add your code for this event here: 
}

export function footer1_click(event) {
	//Add your code for this event here: 
}

export function footer1_dblClick(event) {
	//Add your code for this event here: 
}

export function footer1_dblClick_1(event) {
	//Add your code for this event here: 
}